import { useGo } from '../../app/navigation';
import { useSubPath } from '../../app/useSubPath';
import { Icon, type IconName } from '../../ui/icons';
import { Rich } from '../../ui/Rich';
import { vars } from '../../ui/style';
import { Analyzer } from './Analyzer';
import { ChordLibrary } from './ChordLibrary';
import { Metronome } from './Metronome';
import { TunerPage } from './TunerPage';

const TOOLS: [string, IconName, string, string][] = [
  ['araclar.akort', 'tuner', 'Akort aleti', 'Mikrofonla gitar akortu, referans sesler ve {{n:A4}} kalibrasyonu.'],
  ['araclar.metronom', 'metronome', 'Metronom', 'Tempo, ölçü, vurgu ve tempo vurma.'],
  ['araclar.kutuphane', 'chordbox', 'Akor kütüphanesi', 'Açık, barre ve renkli akorların şemaları ve sesleri.'],
  ['araclar.analiz', 'wave', 'Canlı ses analizi', 'Perde grafiği, sent sapması, vibrato ölçümü ve akor tanıma.'],
  ['vokal.aralik-testi', 'voice', 'Ses aralığı testi', 'En kalın ve en ince rahat notanı bul, ses tipini öğren.'],
];

export function ToolsSection() {
  const go = useGo();
  const [sub] = useSubPath();
  if (sub === 'akort') return <TunerPage />;
  if (sub === 'metronom') return <Metronome />;
  if (sub === 'kutuphane') return <ChordLibrary />;
  if (sub === 'analiz') return <Analyzer />;
  return (
    <div style={vars({ '--mod': 'var(--accent)' })}>
      <header className="mod-head">
        <div className="mod-icon">
          <Icon name="tuner" />
        </div>
        <div className="mod-titles">
          <h1>Araçlar</h1>
          <p>Her çalışmada işine yarayacak yardımcılar.</p>
        </div>
      </header>
      <div className="tool-grid" style={{ marginTop: '22px' }}>
        {TOOLS.map(([route, icon, title, desc]) => (
          <button key={route} type="button" className="tool-big" onClick={() => go(route)}>
            <span className="tb-ic">
              <Icon name={icon} />
            </span>
            <h3>{title}</h3>
            <p>
              <Rich text={desc} />
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
